<script>
  /* Executable code section of the program */
  //Tools imporation
  import {
    userRealTime,
    isChatModalOn,
    temporalChatAttendee,
    confirmationResponse,
    chatId,
    alertMessagge,
    isAlertOn,
    isConfirmModalOn,
    confirmResponse,
    isReloadNecessary,
    eventRealTime,
    attendeesData,
    lastMeetScheduled,
    isAttendeeMeetModalOn,
    meetingInfo,
    noSlotsModalOn
  } from "../../apis/storage";
  import {
    deleteCustomElements,
    deleteDocument,
    getLocalData,
    getSpecificDocuments,
    updateOneDocument,
    listenToDocument,
    getOneDocument,
  } from "../../apis/APIS";
  import { sendMeetEmail } from "../../apis/apisSendEmail";
  import { onDestroy, onMount } from "svelte";

  //Components importation
  import ModalBreakAttendees from "../Modals/ModalBreakAttendees.svelte";
  import ConfirmModal from "../Modals/ConfirmModal.svelte";
  import NoSlotsModal from "../Modals/NoSlotsModal.svelte";

  //Listener Variables
  let unsubscribeEvent;
  let unsubscribeBreak;

  //Auxiliary variables
  export let cardContent;
  export let colorBtn;
  let actualBreak;
  let areInvited = false;
  let scheduledMeetings;

  if (cardContent.meetType === "Regular") {
    if (cardContent.invitedAttendees[0].id === $userRealTime.id) {
      areInvited = true;
    }
  }

  //Function to check if a previous chat exists between attendees.
  const verifyAttendeesChat = (hostId, attendeeId) => {
    for (const chat of $userRealTime.myChats) {
      const chatIdArray = chat.chatId.split("-");

      if (chatIdArray.includes(hostId) && chatIdArray.includes(attendeeId)) {
        return { state: true, chatId: chat.chatId }; // Return true immediately if a match is found
      }
    }
    return { state: false, chatId: "" }; // Return false if no match is found
  };

  //Function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };

  
  //Function to display chat modal normal
  const displayNormalChat = async () => {
    let attendee;
    let user = await getLocalData("user");
    let activeUser = user[0];
    let host = cardContent.host;
    if (cardContent.meetType === "Regular") {
      attendee = cardContent.invitedAttendees[0];
    } else {
      attendee = $userRealTime;
    }

    //Section to check for the existence of a previous chat group

    let response = verifyAttendeesChat(host.id, attendee.id);
    if (response.state) {
      $chatId = response.chatId;
      $temporalChatAttendee =
        attendee.id === activeUser[0].id
          ? { ...host, chatId: response.chatId }
          : { ...attendee, chatId: response.chatId };
    } else {
      $temporalChatAttendee =
        attendee.id === activeUser[0].id
          ? { ...host, chatId: response.chatId }
          : { ...attendee, chatId: response.chatId };
    }

    $isChatModalOn = true;
  };
  //Function to display confirm modal
  const displayConfirmModal = () => {
    $isConfirmModalOn = true;
    $alertMessagge = "Are you sure you want to delete this meeting?";
  };

  //Function to delete a meeting
  const deleteMeeting = () => {
    if ($confirmResponse) {
      let attendees = [];
      attendees.push({
        id: cardContent.host.id,
        fieldName: "scheduledMeetings",
        values: [cardContent.id],
      });
      attendees.push({
        id: cardContent.invitedAttendees[0].id,
        fieldName: "scheduledMeetings",
        values: [cardContent.id],
      });

      deleteDocument("meetings", cardContent.id)
        .then(() => {
          deleteCustomElements("users", attendees)
            .then(() => {
              $alertMessagge = "Meeting deleted successfully";
              $isReloadNecessary = true;
              displayAlert();
            })
            .catch(() => {
              $alertMessagge = "An error occurred while deleting the meet.";
              displayAlert();
            });
        })
        .catch(() => {
          $alertMessagge = "An error occurred while deleting the meet.";
          $isReloadNecessary = true;
          displayAlert();
        });
    }
  };

  ////////////////////////////////////////////////////Seccion de funciones para la aceptacion o rechazo de las meets /////////////////////////////////
  
  //Function to decline meet
  const declineMeet = async (confirm) => {
    if (cardContent.meetType !== "Custom") {
      cardContent.meetStatus = confirm;

      //Funcion para cambiar en mi perfil el estatus del meet
      sendMeetEmail(cardContent.host.email, $userRealTime, "Declined",window.location.pathname.split("/")[2]).then(
        () => {
          updateOneDocument("meetings", cardContent, cardContent.id).then(
            () => {
              $alertMessagge = "Meeting invitation declined";
              displayAlert();
            }
          );
        }
      );
    }
  };
  //Function to decline a custom meet
  const declineCustomMeet = () => {
    cardContent.invitedAttendees = cardContent.invitedAttendees.filter(
      (element) => element.id !== $userRealTime.id
    );
    cardContent.declinedAttendees.push({
      attendeeId: $userRealTime.id,
      attendeeName: $userRealTime.name,
      attendeeSurname: $userRealTime.surname,
      attendeeCompany: $userRealTime.company,
      attendeeJobittle: $userRealTime.jobtittle,
      attendeeCountry: $userRealTime.country
    });
    sendMeetEmail(cardContent.host.email, $userRealTime, "Declined",window.location.pathname.split("/")[2]).then(
      () => {
        updateOneDocument("meetings", cardContent, cardContent.id).then(() => {
          updateOneDocument("events", $eventRealTime, $eventRealTime.id);
          $alertMessagge = "There are no available slots for this meeting.";
          displayAlert();
          return "Declined";
        });
      }
    );
  };

  //Function to accept meet
  const acceptMeet = async(confirm) => {

    /* Regular meetings manage */
    if (cardContent.meetType !== "Custom") {
      
    /* Get current break info */

    let realTimeBreak = await getOneDocument("breaks", cardContent.breakId);

    let fallbackEndTime = realTimeBreak.scheduledMeetings.meetingTime.endTime;
    let falbackFinalTime = realTimeBreak.endTime;
    let [endHour, endMinutes] = fallbackEndTime.split(":").map(Number);
    let [endFinaltHour, endFinalMinutes] = falbackFinalTime
      .split(":")
      .map(Number);      

    let endSchedulTime = endHour * 60 + endMinutes;
    let endFinalTime = endFinaltHour * 60 + endFinalMinutes;
      if (
        endSchedulTime >= endFinalTime
      ) {
        $noSlotsModalOn = true
        cardContent.meetStatus = "declined"
        updateOneDocument("meetings", cardContent, cardContent.id)
      } else {
        schedulMeetings().then((result) => {
          cardContent.meetStatus = confirm;
          //Funcion para cambiar en mi perfil el estatus del meet

          sendMeetEmail(cardContent.host.email, $userRealTime, "Accepted",window.location.pathname.split("/")[2]).then(
            () => {
              updateOneDocument("meetings", cardContent, cardContent.id).then(
                () => {
                  updateOneDocument("breaks", actualBreak, actualBreak.id);
                  updateOneDocument(
                    "events",
                    $eventRealTime,
                    $eventRealTime.id
                  );
                  $alertMessagge = "Meeting invitation accepted";
                  displayAlert();
                }
              );
            }
          );
        });
      }
    } else {
      /* Custom meetings manage */
      let realTimeBreak = await getOneDocument("breaks", cardContent.breakId);
      if (realTimeBreak.limitAttendees > 0) {
        cardContent.limitAttendees = parseInt(cardContent.limitAttendees) - 1;
        cardContent.acceptedAttendees.push({
          attendeeId: $userRealTime.id,
          attendeeName: $userRealTime.name,
          attendeeSurname: $userRealTime.surname,
          attendeeCompany: $userRealTime.company,
          attendeeJobittle: $userRealTime.jobtittle,
        });
        realTimeBreak.limitAttendees = parseInt(actualBreak.limitAttendees) - 1;
        cardContent.meetStatus =
          cardContent.acceptedAttendees.length > 0 ? confirm : "pending";

        //Funcion para cambiar en mi perfil el estatus del meet
        cardContent.invitedAttendees = cardContent.invitedAttendees.filter(
          (element) => element.id !== $userRealTime.id
        );
        sendMeetEmail(cardContent.host.email, $userRealTime, "Accept",window.location.pathname.split("/")[2]).then(
          () => {
            
            updateOneDocument("meetings", cardContent, cardContent.breakId).then(
              () => {
                
                updateOneDocument("breaks", actualBreak, actualBreak.id);
                
                updateOneDocument("events", $eventRealTime, $eventRealTime.id);
                
                $alertMessagge = "Meeting invitation accepted";
                displayAlert();
              }
            );
          }
        );
      } else {
        cardContent.invitedAttendees = cardContent.invitedAttendees.filter(
          (element) => element.id !== $userRealTime.id
        );
        cardContent.declinedAttendees.push({
          attendeeId: $userRealTime.id,
          attendeeName: $userRealTime.name,
          attendeeSurname: $userRealTime.surname,
          attendeeCompany: $userRealTime.company,
          attendeesjobittle: $userRealTime.jobtittle,
        });

        updateOneDocument("meetings", cardContent, cardContent.id).then(() => {
          updateOneDocument("events", $eventRealTime, $eventRealTime.id);
          $alertMessagge = "There are no available slots for this meeting.";
          displayAlert();
          return;
        });
      }
    }
  };

  /////////////////////////////////////// Funciones para la creacion de un meet automatico ///////////////////////////////////////////////////////////////////////////

  const getNextTimeSlot = (startTime, endTime) => {
    const timerObject = {};
    const slotDuration = parseInt(cardContent.slotTime); // en minutos

    // Convertir horas a minutos totales
    const [startHour, startMinutes] = startTime.split(":").map(Number);
    const [endHour, endMinutes] = endTime.split(":").map(Number);

    const startTotalMinutes = startHour * 60 + startMinutes;
    const endTotalMinutes = endHour * 60 + endMinutes;

    // Caso en que los horarios son iguales
    if (startTotalMinutes === endTotalMinutes) {
      const newEndMinutes = endTotalMinutes + slotDuration;
      const resultEndHour = Math.floor(newEndMinutes / 60);
      const resultEndMinutes = newEndMinutes % 60;

      timerObject.startTime = endTime;
      timerObject.endTime = `${String(resultEndHour).padStart(2, "0")}:${String(resultEndMinutes).padStart(2, "0")}`;
    } else {
      const newEndMinutes = startTotalMinutes + slotDuration;
      const resultEndHour = Math.floor(newEndMinutes / 60);
      const resultEndMinutes = newEndMinutes % 60;

      timerObject.startTime = startTime;
      timerObject.endTime = `${String(resultEndHour).padStart(2, "0")}:${String(resultEndMinutes).padStart(2, "0")}`;
    }

    return timerObject;
  };

  //Auxiliary functions to schedul meetings
  //Funcion para obtener el tiempo en numeros de las hora inicial y final del break junto con el tiempo actual
  const timeManagement = () => {
    let date = new Date();
    let [startHour, startMinutes] = cardContent.meetingTime.startTime
      .split(":")
      .map(Number);
    let [endHour, endMinutes] = cardContent.meetingTime.endTime
      .split(":")
      .map(Number);

    let startTotalMinutes = startHour * 60 + startMinutes;
    let endTotalMinutes = endHour * 60 + endMinutes;
    let currentTime = date.getHours() * 60 + date.getMinutes();

    return {
      startTotalMinutes: startTotalMinutes,
      endTotalMinutes: endTotalMinutes,
      currentTime: currentTime,
    };
  };

  //Function to add the first meeting of the break
  const firtsBreakMeet = (tableName = "") => {
    if (tableName !== "") {
      cardContent.meetingCustomTable = tableName;
      cardContent.meetingTable = 1;
      scheduledMeetings.meetingTable = 0;
    } else {
      cardContent.meetingTable = 1;
      scheduledMeetings.meetingTable = 1;
    }
    // Asignar horario

    cardContent.meetingTime = getNextTimeSlot(
      cardContent.meetingTime.startTime,
      cardContent.meetingTime.endTime
    );
    scheduledMeetings.meetingTime = getNextTimeSlot(
      cardContent.meetingTime.startTime,
      cardContent.meetingTime.endTime
    );
  };

  //Function to schedule the other break meetings
  const otherBreaksMeets = (tableName = "") => {
    let lastTable = parseInt(scheduledMeetings.meetingTable);
    let lastStartTime = scheduledMeetings.meetingTime.startTime;
    let lastEndTime = scheduledMeetings.meetingTime.endTime;

    if (lastTable >= cardContent.totalTables) {
      //Last meeting controller
      //Variables
      //Final break time
      let [endHour, endMinutes] = cardContent.meetingTime.endTime
        .split(":")
        .map(Number);
      //Last scheduled meet
      let [endLastHour, endLastMinutes] = lastEndTime.split(":").map(Number);

      //Number convertation
      let finalHour = endHour * 60 + endMinutes;
      let lastHour = endLastHour * 60 + endLastMinutes;

      if (lastHour <= finalHour) {
        if (tableName !== "") {
          cardContent.meetingCustomTable = tableName;
        }
        cardContent.meetingTable = 1;
        scheduledMeetings.meetingTable = 1;
        cardContent.meetingTime = getNextTimeSlot(lastEndTime, lastEndTime);
        scheduledMeetings.meetingTime = getNextTimeSlot(
          lastEndTime,
          lastEndTime
        );
      } else {
        $alertMessagge =
          "All possible meetings for this networking break have already been scheduled. Please wait for the next networking break to organize your meeting.";
        displayAlert();
        return;
      }
    } else {
      if (tableName !== "") {
        cardContent.meetingCustomTable = tableName;
        cardContent.meetingTable = lastTable;
        scheduledMeetings.meetingTable = lastTable;
      } else {
        cardContent.meetingTable = lastTable + 1;
        scheduledMeetings.meetingTable = lastTable + 1;
      }
      cardContent.meetingTime = getNextTimeSlot(
        lastStartTime,
        cardContent.meetingTime.endTime
      );
      scheduledMeetings.meetingTime = getNextTimeSlot(
        lastStartTime,
        cardContent.meetingTime.endTime
      );
    }
  };

  const schedulMeetings = () => {
    return new Promise((resolve, reject) => {
      try {
        const { startTotalMinutes, endTotalMinutes, currentTime } =
          timeManagement();

        /* if (
          currentTime <= endTotalMinutes - parseInt(cardContent.slotTime) &&
          startTotalMinutes <= endTotalMinutes - parseInt(cardContent.slotTime)
        ) { */
        if ($userRealTime.userRole === "attendee") {
          const hasCustomTables = cardContent.meetingCustomTable !== "";
          const tableName = hasCustomTables
            ? cardContent.meetingCustomTable
            : "";

          const isFirstMeeting =
            !scheduledMeetings.meetingTable ||
            scheduledMeetings.meetingTable === 0;

          if (isFirstMeeting) {

            firtsBreakMeet(tableName);
          } else {

            otherBreaksMeets(tableName);
          }
        }

        resolve({
          message: "Meeting scheduled successfully.",
          meetingTime: cardContent.meetingTime,
          meetingTable: cardContent.meetingTable,
        });
        /* } else {
          const msg = "There are no available times to schedule a meeting.";
          $alertMessagge = msg;
          displayAlert();
          reject(new Error(msg));
        } */
      } catch (error) {
        reject(error);
      }
    });
  };

  //Funcion para manejar el estado de meet cuando es un custom meet
  const getStatusById = (
    id,
    invitedAttendees,
    declineAttendees,
    acceptAttendees
  ) => {
    const isInArray = (arr) =>
      arr.some((item) => item.attendeeId === id || item.id === id);

    if (isInArray(invitedAttendees)) {
      return "Pending";
    } else if (isInArray(declineAttendees)) {
      return "Declined";
    } else if (isInArray(acceptAttendees)) {
      return "Accepted";
    } else {
      return "Not Found"; // Opcional: en caso de que no esté en ningún array
    }
  };

  const customMeetStatus = (acceptedAttendees, id) => {
    const isAccepted = acceptedAttendees.some(
      (attendee) => attendee.attendeeId === id
    );
    return isAccepted ? "Accepted" : "Pending";
  };

  const declineMeetStatus = (invitedAttendees, id) => {
    const isAccepted = invitedAttendees.some((attendee) => attendee.id === id);
    return !isAccepted ? "Declined" : "";
  };

  const seeAttendees = () =>{

    $isAttendeeMeetModalOn = true
    $meetingInfo = cardContent
  }

  /* Functions to listen the changes  */
  onMount(async () => {
    unsubscribeBreak = listenToDocument(
      "breaks",
      cardContent.breakId,
      (data) => {
        actualBreak = data;
        scheduledMeetings = data.scheduledMeetings;
      }
    );

    unsubscribeEvent = listenToDocument(
      "meetings",
      cardContent.id,
      async (data) => {
        if (!data) return;

        if (typeof data === "string") {
          cardContent = await getOneDocument("meetings", data);
        } else {
          cardContent = data;
        }
      }
    );
  });

  onDestroy(() => {
    if (unsubscribeEvent) unsubscribeEvent(); // 🔥 importante
    if (unsubscribeBreak) unsubscribeBreak(); // 🔥 importante
  });


  /* End of the section */
</script>

<!-- Section to place the HTML code -->

<section
  class="cardContainer"
  style="--event-Color: {colorBtn}; border: 10px solid {colorBtn}; color:white;"
>
  <div class="infoMeet">
    <p class="text">
      <b>Attendees</b> <br />
      <b>Sender: </b>
      {cardContent.host.name}
      {cardContent.host.surname} <br />
      <!-- Custom break receiver -->
      {#if cardContent.meetType === "Custom"}
        <b>Receiver: </b>Multiple Attendees<br />
      {:else}
        <b>Receiver: </b>{cardContent.invitedAttendees[0].name}
        {cardContent.invitedAttendees[0].surname}<br />
      {/if}
      <b>Meeting Tittle: </b>{cardContent.breakTittle || "N/A"} <br />

      <!-- Custom status -->
      {#if cardContent.meetType === "Custom"}
        <b>Meeting Status: </b>
        {customMeetStatus(cardContent.acceptedAttendees, $userRealTime.id)}
        <br />

        <!-- Regular Status -->
      {:else}
        <b>Meeting Status: </b>{cardContent.meetStatus.charAt(0).toUpperCase() +
          cardContent.meetStatus.slice(1)} <br />
      {/if}
      <b>Meeting Time: </b>
      {cardContent.meetingTime.startTime}hs - {cardContent.meetingTime
        .endTime}hs <br />
      {#if cardContent.meetType === "Regular"}
        <b>Meeting Duration: </b>
        {cardContent.slotTime} minutes <br />
      {/if}
      <!-- Meet place only in custom breaks cards -->
      {#if cardContent.meetType === "Custom"}
        {#if getStatusById($userRealTime.id, cardContent.invitedAttendees, cardContent.declinedAttendees, cardContent.acceptedAttendees) === "Declined"}
          <br /><b>Note: </b>All available slots for this meeting have already
          been assigned. Contact the sender to schedule a new meeting or speak
          with them directly. <br />
        {:else}
          <b>Meeting Place: </b>{cardContent.placeBreak}
        {/if}
      {/if}
      <!-- Table number or name only in a regular break cards -->
      {#if cardContent.meetStatus === "accepted"}
        {#if cardContent.meetType === "Regular"}
          {#if cardContent.meetingCustomTable === "" || cardContent.meetingCustomTable === undefined}
            <b>Meeting Table</b>: {cardContent.meetingTable} <br />
          {:else}
            <b>Meeting Table</b>: {cardContent.meetingCustomTable} <br />
          {/if}
        {/if}
      {/if}
    </p>
  </div>
  <div class="btnSection">
    <!-- Section to regular break buttons -->
    {#if cardContent.meetType === "Regular"}
      {#if areInvited && cardContent.meetStatus === "pending"}
        <button
          class="actionBtn acceptMeetBtn"
          on:click={() => acceptMeet("accepted")}>Accept</button
        >
        <button
          class="actionBtn cancelMeetBtn"
          on:click={() => declineMeet("declined")}>Decline</button
        >
      {:else if cardContent.meetStatus === "accepted" && cardContent.meetType === "Custom"}
        {#if $userRealTime.id === cardContent.host.id}
          <button class="actionBtn cancelMeetBtn" on:click={displayConfirmModal}
            >Cancel Meeting</button
          >
        {/if}
        <button class="actionBtn cancelMeetBtn" on:click={displayNormalChat}
          >Chat</button
        >
      {:else}
        <button class="actionBtn cancelMeetBtn" on:click={displayConfirmModal}
          >Cancel Meeting</button
        >
        <button class="actionBtn cancelMeetBtn" on:click={displayNormalChat}
          >Chat</button
        >
      {/if}
      <!-- End regular buttons section -->

      <!-- Custom buttons section -->
    {:else if $userRealTime.id === cardContent.host.id}
      <button class="actionBtn cancelMeetBtn" on:click={displayConfirmModal}
        >Cancel Meeting</button
      >
      <button class="actionBtn cancelMeetBtn" on:click={seeAttendees}
        >See Attendees</button
      >
      <!-- <button class="actionBtn cancelMeetBtn" on:click={displayNormalChat}
        >Chat</button
      > -->
    {:else if getStatusById($userRealTime.id, cardContent.invitedAttendees, cardContent.declinedAttendees, cardContent.acceptedAttendees) === "Accepted"}
      <button class="actionBtn cancelMeetBtn" on:click={displayNormalChat}
        >Chat</button
      >
    {:else if getStatusById($userRealTime.id, cardContent.invitedAttendees, cardContent.declinedAttendees, cardContent.acceptedAttendees) === "Declined"}
      <button class="actionBtn cancelMeetBtn" on:click={displayNormalChat}
        >Chat</button
      >
    {:else if getStatusById($userRealTime.id, cardContent.invitedAttendees, cardContent.declinedAttendees, cardContent.acceptedAttendees) === "Pending"}
      <button
        class="actionBtn acceptMeetBtn"
        on:click={() => acceptMeet("accepted")}>Accept</button
      >
      <button
        class="actionBtn cancelMeetBtn"
        on:click={() => declineCustomMeet()}>Decline</button
      >
    {/if}
    <!-- End custom buttons section -->
  </div>
</section>
{#if $isConfirmModalOn}
  <ConfirmModal callbackFunction={deleteMeeting} />
{/if}
{#if $isAttendeeMeetModalOn && cardContent.meetType === "Custom"}
  <ModalBreakAttendees/>
{/if}
{#if $noSlotsModalOn}
  <NoSlotsModal/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .cardContainer {
    width: 30%;
    height: auto;
    background-color: white;
    margin: 10px;
    color: black;
    padding: 20px;
  }
  .infoMeet {
    color: black;
    text-align: center;
  }
  .text {
    width: 100%;
    border-bottom: 1px solid gray;
    padding: 15px 0;
  }
  /* Buttons styles */
  .btnSection {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
  }
  .actionBtn {
    width: 200px;
    height: auto;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 10px;
  }
  .cancelMeetBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .acceptMeetBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: rgb(14, 182, 14);
    color: White;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .cardContainer {
      margin: 5px;
      width: 45%;
      padding: 15px;
    }
    .btnSection {
      width: 100%;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .cardContainer {
      width: 100%;
      padding: 10px;
    }
    .btnSection {
      align-items: center;
      flex-direction: column;
    }

    .text {
      width: 100%;
      text-align: center;
    }
  }
  /* End of the section */
</style>
